import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
// import PrimeVue from 'primevue/config'; // comment jap
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Editor from 'primevue/editor';
import InputSwitch from 'primevue/inputswitch';
import Checkbox from 'primevue/checkbox';
import vSelect from 'vue-select';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import Dialog from "primevue/dialog";
import Menubar from 'primevue/menubar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import RadioButton from 'primevue/radiobutton';
import Chips from 'primevue/chips';
import MultiSelect from 'primevue/multiselect';
import Card from 'primevue/card';
import AutoComplete from 'primevue/autocomplete';
import SelectButton from 'primevue/selectbutton';
import FileUpload from 'primevue/fileupload';
import Slider from 'primevue/slider';
import VeeValidate, { Validator } from 'vee-validate'; //npm i vee-validate@2.1.7 --save
import Sidebar from 'primevue/sidebar';
import Menu from 'primevue/menu';
import VueSidebarMenu from 'vue-sidebar-menu'
import { NumbersOnly } from './directives/numberOnly';
import Calendar from 'primevue/calendar';
import VueFilterDateFormat from 'vue-filter-date-format'; //npm install vue-filter-date-format
import Loading from 'vue-loading-overlay';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import VueSkeletonLoader from "skeleton-loader-vue";
import 'vue-loading-overlay/dist/vue-loading.css';
import AxiosPlugin from 'vue-axios-cors';
import Carousel from 'primevue/carousel';
import ProgressBar from 'primevue/progressbar';
import MegaMenu from 'primevue/megamenu';
import Tooltip from 'primevue/tooltip';
import Paginator from 'primevue/paginator';
import Chart from 'primevue/chart';
import Breadcrumb from 'primevue/breadcrumb';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import SocialSharing from "vue-social-sharing";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import Rating from 'primevue/rating';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'bootstrap';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'vue-select/dist/vue-select.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './style.scss';


import firebase from "firebase/app";
import 'firebase/firebase-messaging';
import VueJsonToCsv from 'vue-json-to-csv'
import OverlayPanel from 'primevue/overlaypanel';
import VueSimpleAlert from "vue-simple-alert";
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

Vue.config.productionTip = false;
Vue.prototype.$primevue = Vue.observable({
  config: {
    ripple: true,
    locale: {
      firstDayOfWeek: 0,
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      monthNames: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      monthNamesShort: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ],
      today: 'Today',
      clear: 'Clear'
    }
  }
});

Validator.extend('verify_password', {
  // getMessage: field => `The password must contain at least one uppercase, one lowercase letter, one number, and one special character`,
  getMessage: field => `The password must contain at least 8 characters`,
  // validate: value => {
  //   var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
  //   return strongRegex.test(value);
  // }
  validate: value => {
    const strongRegex = new RegExp("^(?=.*[a-zA-Z0-9!@#\$%\^&\*])(?=.{8,})");
    return strongRegex.test(value);
  }
});

Vue.use(VeeValidate, {
  Validator
});

// Vue.use(PrimeVue, {
//   ripple: true
// });

Vue.component('InputText', InputText);
Vue.component('Dropdown', Dropdown);
Vue.component('Editor', Editor);
Vue.component('InputSwitch', InputSwitch);
Vue.component('Checkbox', Checkbox);
Vue.component('v-select', vSelect);
Vue.component('Textarea', Textarea);
Vue.component('Button', Button);
Vue.component("Dialog", Dialog);
Vue.component("Menubar", Menubar);
Vue.component("TabView", TabView);
Vue.component("TabPanel", TabPanel);
Vue.component("RadioButton", RadioButton);
Vue.component("Chips", Chips);
Vue.component("MultiSelect", MultiSelect);
Vue.component("Card", Card);
Vue.component("AutoComplete", AutoComplete);
Vue.component("SelectButton", SelectButton);
Vue.component("FileUpload", FileUpload);
Vue.component("Slider", Slider);
Vue.component("Sidebar", Sidebar);
Vue.component("Menu", Menu);
Vue.component("Calendars", Calendar);
Vue.component("Carousel", Carousel);
Vue.component("ProgressBar", ProgressBar);
Vue.component("MegaMenu", MegaMenu);
Vue.component("DataTable", DataTable);
Vue.component("Column", Column);
Vue.component("ColumnGroup", ColumnGroup);
Vue.component("Rating", Rating);

Vue.directive("numbersOnly", NumbersOnly);
Vue.directive("tooltip", Tooltip);
Vue.component("Paginator", Paginator);
Vue.component("Chart", Chart);
Vue.component("Breadcrumb", Breadcrumb);
Vue.component("Accordion", Accordion);
Vue.component("AccordionTab", AccordionTab);
Vue.component("firebase",firebase);
Vue.component("VueJsonToCsv",VueJsonToCsv);
Vue.component("OverlayPanel",OverlayPanel);
Vue.component("Toast",Toast);
// Vue.component("VueSimpleAlert",VueSimpleAlert)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(AxiosPlugin)
Vue.use(VueFilterDateFormat);
Vue.use(SocialSharing);
Vue.use(VueSidebarMenu);
Vue.use(VueSimpleAlert);
Vue.use(ToastService);
Vue.use(Loading, {
  canCancel: false,
  color: '#333d94',
  loader: 'spinner',
  width: 64,
  height: 64,
  backgroundColor: '#ffffff',
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default {
  VeeValidate
}


